



































import { PropType } from 'vue';
import { iconClassEnum } from '../../../../shared/enums/iconClassEnum';
import EventDetailsTimeslot from './EventDetailsTimeslot.vue';
import { calendarService } from '../../../../shared/services/api/calendar.service';
import { RespondToTimeSlotEventRequest } from '../../../../shared/models/requests/respondToTimeSlotEvent.request';
import { UpdateResponseToTimeSlotEventRequest } from '../../../../shared/models/requests/updateResponseToTimeSlotEvent.request';
import { TimeslotModel } from '../../../../shared/models/timeslot.model';
import { TimeslotAnswerModel } from '../../../../shared/models/timeslotAnswer.model';
import { BlockTimeSlotRequest } from '../../../../shared/models/requests/blockTimeSlot.request';
import { RemoveBlockingOrResponseToTimeSlotRequest } from '../../../../shared/models/requests/removeBlockingOrResponseToTimeSlot.request';
import { eventResponseStatus } from '../../../../shared/enums/eventResponseStatus';
import { DateTimeUtil } from '../../../../shared/utils/dateTimeUtil';
import { dateFormatEnum } from '../../../../shared/enums/dateFormatEnum';
import { EventData } from '../../../business/calendar/eventData';
import orderBy from 'lodash/orderBy';

export default {
  components: { EventDetailsTimeslot },
  props: {
    eventData: { type: Object as PropType<EventData>, required: true },
  },
  emits: ['updated', 'responded'],
  data() {
    return {
      isShownTimeslots: false,
      selectedSlot: null,
    };
  },
  computed: {
    eventResponseStatus() {
      return eventResponseStatus;
    },
    iconClassEnum() {
      return iconClassEnum;
    },
    timeslots() {
      return orderBy(this.eventData.timeSlot.timeSlots, [slot => new Date(slot.startDate).getTime()], ['asc']);
    },
    answers() {
      return this.eventData.timeSlot.timeSlots.flatMap((timeslot: TimeslotModel) => timeslot.answers);
    },
    hasResponded() {
      return this.eventData.respondedTimeslot != null;
    },
  },
  created() {
    this.isShownTimeslots = !this.hasResponded || !this.eventData.canRespond;
  },
  methods: {
    toggleTimeslotView() {
      this.isShownTimeslots = !this.isShownTimeslots;
    },
    async handleSlotAssigned({timeslotId, timeslotIndex, invitee}) {
      const hasAnswered = this.answers.some(
        (answer: TimeslotAnswerModel) => answer.concerningProfile?.id === invitee.instProfile.id
      );

      if (hasAnswered) {
        await this.reassign({timeslotId, timeslotIndex, institutionProfile: invitee.instProfile});
      } else {
        await this.assign({timeslotId, timeslotIndex, institutionProfile: invitee.instProfile});
      }
      this.$showToast(this.$t('warning.changes_saved'));
      this.$emit('updated');
    },
    async assign({ timeslotId, timeslotIndex, institutionProfile  }) {
      const payload: RespondToTimeSlotEventRequest = {
        eventId: this.eventData.id,
        timeSlotId: timeslotId,
        timeSlotIndex: timeslotIndex,
        concerningInstProfileId: institutionProfile.id,
      };
      await calendarService.respondToTimeSlotEvent(payload);
    },
    async reassign({ timeslotId, timeslotIndex, institutionProfile  }) {
      const payload: UpdateResponseToTimeSlotEventRequest = {
        eventId: this.eventData.id,
        timeSlotId: timeslotId,
        timeSlotIndex: timeslotIndex,
        concerningInstProfileId: institutionProfile.id,
      };
      await calendarService.updateResponseToTimeSlotEvent(payload);
    },
    async handleSlotBlocked({ timeslotId, timeslotIndex }) {
      const payload: BlockTimeSlotRequest = {
        eventId: this.eventData.id,
        timeSlotId: timeslotId,
        timeSlotIndex: timeslotIndex,
      };
      await calendarService.blockTimeSlot(payload);
      this.$showToast(this.$t('warning.changes_saved'));
      this.$emit('updated');
    },
    async handleSlotCleared({ timeslotId, timeslotIndex, invitee = null }) {
      const payload: RemoveBlockingOrResponseToTimeSlotRequest = {
        eventId: this.eventData.id,
        timeSlotId: timeslotId,
        timeSlotIndex: timeslotIndex,
        concerningInstitutionProfileId: invitee?.instProfile?.id,
      };
      await calendarService.removeBlockingOrResponseToTimeSlot(payload);
      this.$showToast(this.$t('warning.changes_saved'));
      this.$emit('updated');
    },
    async handleTimeslotSaved() {
      const {index: timeslotIndex, timeslotId} = this.selectedSlot;
      const {regardingProfile: institutionProfile} = this.eventData;
      const selectedIndex = this.timeslots.find(slot => slot.id == this.selectedSlot.timeslotId)?.timeSlotIndexes[
        this.selectedSlot.index
        ];
      if (this.hasResponded) {
        const startTime = DateTimeUtil.formatDate(selectedIndex.startTime, dateFormatEnum.SHORT_TIME);
        const endTime = DateTimeUtil.formatDate(selectedIndex.endTime, dateFormatEnum.SHORT_TIME);
        if (!(await this.$confirmAction(this.$t('warning.respond_to_timeslot', {startTime, endTime})))) {
          return;
        }
        await this.reassign({timeslotId, timeslotIndex, institutionProfile});
      } else {
        await this.assign({timeslotId, timeslotIndex, institutionProfile});
      }
      this.$showToast(this.$t('warning.changes_saved'));
      this.$emit('responded');
    },
    async handleMeetingDeclined() {
      const warning1 = this.$createElement('p', { domProps: { innerHTML: this.$t('warning.decline_meeting_1') } });
      const warning2 = this.$createElement('p', { domProps: { innerHTML: this.$t('warning.decline_meeting_2') } });
      const isConfirmed = await this.$confirmAction([warning1, warning2]);
      if (isConfirmed) {
        await this.decline();
      }
    },
    async decline() {
      const payload: RemoveBlockingOrResponseToTimeSlotRequest = {
        eventId: this.eventData.id,
        timeSlotId: this.eventData.respondedTimeslot.timeslotId,
        timeSlotIndex: this.eventData.respondedTimeslot.index,
        concerningInstitutionProfileId: this.eventData.regardingProfile.id,
      };
      await calendarService.removeBlockingOrResponseToTimeSlot(payload);
      this.$showToast(this.$t('warning.changes_saved'));
      this.$emit('responded');
    },
  },
};
